var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'updateLadingError', params: { id: _vm.ladingErrorId}}}},[_c('a-icon',{attrs:{"type":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }